module.exports = __webpack_public_path__ + "assets/img/activity-time-25c8885a.png";